import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_VENDOR_DINER,
  GET_PENDING_DINER,
  GET_RESERVATION_DINER,
  GET_RESERVATION_TIMING_SLOTS,
  GET_AVAILABLE_TABLE_DATA,
  GET_HISTORY_DINER,
  INC_SEATING_COUNT,
  DEC_SEATING_COUNT,
  SET_LOADER_SECONDARY,
  SET_TWILIO_TOKEN,
} from "../../types";
import Alert from "react-s-alert";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";
import { get_new_subscription_for_vendor } from "../authAction";
import { amApi } from "../../../api/apiHelper";

/***************************************
 * @DESC - ADD OFFERS AND EVENTS ACTION
 *****************************************/
export const vendor_add_diner_reservation =
  (formData, actionText, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_diner_reservaton = await axios.post(
        `${serverApi}/diner`,
        formData
      );
      if (add_diner_reservaton.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>New ${actionText} Add Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

/***********************************************
 * @DESC - GET ALL AVAILABLE TABLE ACTION
 **********************************************/
export const vendor_get_available_table_action =
  (vendorId, startDate, endDate, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let vendor_get_available_table = await axios.get(
        `${serverApi}/table/diner?vendor=${vendorId}&startdate=${startDate}&enddate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (vendor_get_available_table.status === 200) {
        dispatch({
          type: GET_AVAILABLE_TABLE_DATA,
          payload: vendor_get_available_table.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***********************************************
 * @DESC - GET RESERVATION TIMING SLOTS ACTION
 **********************************************/
export const vendor_get_timing_slots_reservation =
  (restaurant_id, newDate, token, min_lead_time) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_timing_slots_reservation = await axios.get(
        `${serverApi}/restaurant-availability/${restaurant_id}?date=${newDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (get_timing_slots_reservation.data) {
        dispatch({ type: CLEAR_LOADER });
        let responseCopy = cloneDeep(get_timing_slots_reservation.data);
        let minimum = parseFloat(min_lead_time) * 60;
        let finalSlots = [];
        let indexTime;
        for (let i = 0; i < responseCopy.length; i++) {
          let time1 = moment(responseCopy[i], "hh:mm A");
          let time2 = moment(new Date(), "hh:mm A").add(minimum, "minutes");

          if (!moment(time2).isAfter(time1, "hh:mm A")) {
            // finalSlots.push(get_timing_slots_reservation.data[i]);
            indexTime = i;
            i = responseCopy.length;
          }
        }
        finalSlots = responseCopy.splice(indexTime);
        dispatch({
          type: GET_RESERVATION_TIMING_SLOTS,
          payload:
            moment(newDate).format("DD-MM-YYYY") ===
            moment(new Date()).format("DD-MM-YYYY")
              ? finalSlots
              : get_timing_slots_reservation.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL SEATING AND RESERVATION
 *****************************************/
export const get_diner_reservation = (vendor_id, token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_diner_reservation = await axios.get(
      `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=SEATING`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_diner_reservation.data) {
      dispatch({
        type: GET_VENDOR_DINER,
        payload: get_diner_reservation.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    console.log(err);
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC - GET ALL PENDING DINER
 *****************************************/
export const get_pending_diner = (vendor_id, token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_pending_diner = await axios.get(
      `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=PENDING`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_pending_diner.data) {
      dispatch({
        type: GET_PENDING_DINER,
        payload: get_pending_diner.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    console.log(err);
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC - INCREMENT SEATING COUNT
 *****************************************/
export const inc_seating_count = () => async (dispatch) => {
  dispatch({ type: INC_SEATING_COUNT });
};

export const dec_seating_count = () => async (dispatch) => {
  dispatch({ type: DEC_SEATING_COUNT });
};

/***************************************
 * @DESC - GET ALL RESERVATION DINER
 *****************************************/
export const get_reservation_diner =
  (vendor_id, token, custom_time) => async (dispatch) => {
    // console.log(vendor_id, token, custom_time)
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_reservation_diner = await axios.get(
        `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=RESERVATION&${
          custom_time === undefined
            ? ""
            : `customTime=${custom_time}` && custom_time === true
            ? `openAll=${custom_time}`
            : `customTime=${custom_time}`
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_reservation_diner.data) {
        dispatch({
          type: GET_RESERVATION_DINER,
          payload: get_reservation_diner.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET SEATING AND RESERVATION
 *****************************************/
export const get_all_diner_history =
  (vendor_id, token, date) => async (dispatch) => {
    // dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let get_all_diner_history = await axios.get(
        `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=HISTORY&startDate=${date.startDate}&endDate=${date.endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_all_diner_history.data) {
        dispatch({
          type: GET_HISTORY_DINER,
          payload: get_all_diner_history.data,
        });
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      console.log(err);
      // dispatch({ type: CLEAR_LOADER });
      // dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - MARK ALL COMPETED ACTION
 *****************************************/
export const vendor_all_completed_diner =
  (formData, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let completeRecord = await axios.patch(
        `${serverApi}/vendor/diner?markComplete=${formData.markComplete}&vendor_id=${formData.vendor_id}`,
        formData,
        {
          headers: {
            Authorization: formData.token,
            "Content-Type": "application/json",
          },
        }
      );
      if (completeRecord.data) {
        dispatch({ type: CLEAR_LOADER });
        const vendor_id = formData.vendor_id;
        const token = formData.token;
        onSuccess();
        // dispatch(get_diner_reservation(vendor_id, token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };

/***************************************
 * @DESC - REJECT PENDING ACTION
 *****************************************/
export const vendor_reject_pending_diner =
  (formData, diner_id, vendor_id, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let rejectedRecord = await axios.patch(
        `${serverApi}/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (rejectedRecord.data) {
        dispatch({ type: CLEAR_LOADER });
        // dispatch(get_diner_reservation(vendor_id));
        // dispatch(get_pending_diner(vendor_id));
        // dispatch(get_reservation_diner(vendor_id));
        // dispatch(get_all_diner_history(vendor_id));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - ACCEPT PENDING ACTION
 *****************************************/
export const vendor_accept_pending_diner =
  (formData, diner_id, vendor_id, token, successCallback) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let acceptRecord = await axios.patch(
        `${serverApi}/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (acceptRecord.data) {
        dispatch({ type: CLEAR_LOADER });
        successCallback();
        dispatch(get_diner_reservation(vendor_id, token));
        // dispatch(get_pending_diner(vendor_id));
        // dispatch(get_reservation_diner(vendor_id));
        // dispatch(get_all_diner_history(vendor_id));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - RESET DINER ACTION
 *****************************************/
export const vendor_reset_diner_request =
  (formData, diner_id, vendor_id, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let resetRecord = await axios.patch(
        `${serverApi}/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (resetRecord.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Diner Record Reset Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        // dispatch(get_diner_reservation(vendor_id));
        // dispatch(get_pending_diner(vendor_id));
        // dispatch(get_reservation_diner(vendor_id));
        // dispatch(get_all_diner_history(vendor_id));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - SEATED WAIT TIME ACTION
 *****************************************/
export const vendor_seated_waittime_request =
  (formData, diner_id, vendor_id, token, onCallBackFunc) =>
  async (dispatch) => {
    // console.log(formData);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let seatedWaitTime = await axios.patch(
        `${serverApi}/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (seatedWaitTime.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(get_new_subscription_for_vendor(formData));
        Alert.success(`<h4>Diner Record Update Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallBackFunc();
        dispatch(get_diner_reservation(vendor_id, token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      Alert.error(
        `<h4>${
          err?.response?.data === undefined ? err : err?.response?.data?.message
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    }
  };

/***************************************
 * @DESC - Assign and Check Table Number
 *****************************************/
export const vendor_assign_check_table_number =
  (formData, diner_id, vendor_id, token, onCallBackFunc, onErrorCheckFunc) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let seatedWaitTime = await axios.patch(
        `${serverApi}/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (seatedWaitTime.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Diner Record Update Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallBackFunc();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorCheckFunc();
    }
  };

/***************************************
 * @DESC - DASHBOARD EDIT ACTION
 *****************************************/
export const vendor_dashboard_edit_action =
  (formData, dinerId, tokenData, onSuccess) => async (dispatch) => {
    // console.log(formData, diner_id, vendor_id, token);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    // added by aman ,Gaurav don't consider this temp_loader for ur code
    dispatch({ type: "TEMP_ADD_LOADER" });

    try {
      let editPendingDinerRecord = await axios.patch(
        `${serverApi}/diner/${dinerId}`,
        formData,
        {
          headers: {
            Authorization: tokenData,
            "Content-Type": "application/json",
          },
        }
      );
      if (editPendingDinerRecord.data) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: "TEMP_REMOVE_LOADER" });
        Alert.success(`<h4>Diner Record Edit Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        // dispatch(get_diner_reservation(vendor_id));
        // dispatch(get_pending_diner(vendor_id));
        // dispatch(get_reservation_diner(vendor_id));
        // dispatch(get_all_diner_history(vendor_id));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - DASHBOARD CHANGE TABLE STATUS
 *****************************************/

export const change_table_status_table_management =
  (subscription_id, table_number, status, token, vendor_id) =>
  async (dispatch) => {
    try {
      let changeStatus = await axios.patch(
        `${serverApi}/subscription/table/${subscription_id}?seating=true`,
        {
          table_number: table_number,
          status: status,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (changeStatus.data) {
        let formData = {
          vendor_id: vendor_id,
        };
        dispatch(get_new_subscription_for_vendor(formData));
        // dispatch(get_diner_reservation(vendor_id, token));
      }
    } catch (err) {
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - EVENT CHANGE TABLE STATUS
 *****************************************/

export const change_table_status_table_management_event =
  (subscription_id, table_number, status, token, vendor_id) =>
  async (dispatch) => {
    try {
      let changeStatus = await axios.patch(
        `${serverApi}/event-handler/${subscription_id}`,
        {
          table_number: table_number,
          event_status: status,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (changeStatus.data) {
        let formData = {
          vendor_id: vendor_id,
        };
        dispatch(get_new_subscription_for_vendor(formData));
      }
    } catch (err) {
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC TWILIO CALLING FUNCTIONS
 ************************************************/
export const get_twilio_calling =
  (vendorToken, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    try {
      let get_twilio_calling_token = await amApi.get(`${serverApi}/token`);
      if (get_twilio_calling_token.status === 200) {
        dispatch({
          type: SET_TWILIO_TOKEN,
          payload: get_twilio_calling_token.data,
        });
        callback(get_twilio_calling_token.data);
      }
    } catch (err) {
      dispatch(setErrors(err));
    }
  };
